<template>
  <Toast ref="toastRef" /> <!-- Ensure the toast reference is set -->
  <MainLoader
    :visible="true"
    size="80px"
    color="blue"
    v-if="!getBookedRoom || !getBookedRoom?.content?.name || bookingStore.getLoading"
    :loaderText="bookingStore.getLoading ? 'Please do not close the window or refresh the page' :'Loading...' "
  />
  <div class="container" v-else>
    <button type="button" @click="backToMainView" class="my-5 mx-auto lsp-btn px-3 py-2 rounded text-sm font-medium">
      <span> &lt; back</span>
    </button>
    <div class="flex gap-4">
      <userInformation :bookedRoom="getBookedRoom" @booking-error="handleBookingError" />
      <bookingDetails :bookedRoom="getBookedRoom" />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import userInformation from "./userInformation.vue";
import bookingDetails from "./bookingDetails.vue";
import { useComponentChangeStore } from "../../stores/componentChange.module.js";
import { useBookingStore } from "../../stores/booking.module.js";
import api from "../../utils/api.js";
import MainLoader from "../../src/UI/mainLoader.vue";
import Toast from "../../src/UI/toast.vue";

const componentChangeStore = useComponentChangeStore();
const bookingStore = useBookingStore();
const getBookedRoom = ref(null);
const toastRef = ref(null);

onMounted(() => {
  restoreBookingData();
  getInitialBookingData();
});

function backToMainView() {
  const payload = getBookedRoomPayload.value;
  
  if (payload && payload.third_party_type === "REQUESTTOBOOK") {
    componentChangeStore.changeTheComponent("r2bView");
  } else {
    componentChangeStore.changeTheComponent("hotelView");
  }
}

const getBookedRoomPayload = computed(() => bookingStore.getBookingRoomValue);


function restoreBookingData() {
  if (
    !getBookedRoomPayload.value ||
    Object.keys(getBookedRoomPayload.value).length === 0
  ) {
    const storedData = JSON.parse(localStorage.getItem("getBookedRoom"));
    if (storedData) {
      bookingStore.addValueToBookingRoom(storedData);
    }
  }
}
const handleBookingError = (error) => {
  if (toastRef.value) {
    toastRef.value.addToast(
      error || 'Booking failed. Please try again.', 
      "error"
    );
  }
};

async function getInitialBookingData() {
  try {
    const payload = getBookedRoomPayload.value;
    if (!payload || Object.keys(payload).length === 0) {
      console.warn("No booking payload available. Skipping API call.");
      return;
    }

    if (payload.third_party_type === "REQUESTTOBOOK" && payload.r2bCheckoutData) {
      getBookedRoom.value = payload.r2bCheckoutData;
      localStorage.setItem(
        "getBookedRoom",
        JSON.stringify(getBookedRoomPayload.value)
      );
      return;
    }

    const res = await api.post("property/checkout", payload);

    getBookedRoom.value = res.data.data;
    localStorage.setItem(
      "getBookedRoom",
      JSON.stringify(getBookedRoomPayload.value)
    );

  } catch (err) {
    if (toastRef.value) {
      toastRef.value.addToast(`${err.response?.data?.message || 'Something went wrong'}`, "error");
    }
    componentChangeStore.changeTheComponent("hotelView");
  }
}
</script>
